import { baseColors, primaryLight, primaryDark } from '@/theme/tokens/base/colors'
import type { AliasTokens } from '@/theme/types'

export type ThemeMode = 'light' | 'dark'

/**
 * Creates brand tokens for the specified theme mode.
 * 
 * CRITICAL: Light and dark themes are fully isolated.
 * Light theme uses #722fa2 as brandPrimary (primaryLight[500]).
 * Dark theme uses #9B6BFF as brandPrimary (primaryDark[500]).
 */
export const createBrandTokens = (mode: ThemeMode): AliasTokens => {
  if (mode === 'dark') {
    // Dark theme brand colors - NEVER modify light theme values
    return {
      brandPrimary: primaryDark[500], // #9B6BFF - основной primary для dark
      brandPrimarySoft: primaryDark[400], // #B08CFF - hover для dark
      brandOnPrimary: '#FFFFFF',
      brandSurface: '#1A1A1A',
      brandBackground: '#121212',
      brandBorder: baseColors.gray[700],
      brandText: baseColors.gray[50],
      brandTextMuted: baseColors.gray[400],
    }
  }

  // Light theme brand colors - SOURCE OF TRUTH: #722fa2
  return {
    brandPrimary: primaryLight[500], // #722fa2 - основной primary для light (SOURCE OF TRUTH)
    brandPrimarySoft: primaryLight[600], // #5E2688 - hover для light (darker shade)
    brandOnPrimary: '#FFFFFF',
    brandSurface: baseColors.gray[50], // белый для карточек, сайдбара
    brandBackground: '#f5f5f5', // подложка страницы — слегка серый, как раньше --bg-light
    brandBorder: baseColors.gray[200],
    brandText: baseColors.gray[900],
    brandTextMuted: baseColors.gray[500],
  }
}

